/**
 * @file: 云加速活动
 * @author: wence
 */
import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

import {confirm} from '../activity';

import {getVoucher, payVoucher} from '../../actions/activitySuAction';
import './index.less';
import {fetchInstanceGetInstance} from '../../actions/buyAction';

class ActivitySu extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isLogin: false,
            voucherList: [],
            serverList: [],
            advServer: {},
            entServer: {}
        };

        this.instanceId = '';

        if (this.isPC()) {
            location.href = '/activity/su';
        }
    }

    resetHtmlFont = () => {
        // 部分机型显示有问题
        const html = document.querySelector('html');
        const fontSize = window.getComputedStyle(html).fontSize.replace('px', '');

        html.style.fontSize = Math.ceil(fontSize) + 'px';
    }

    async componentDidMount() {
        const {fetchInstanceGetInstance} = this.props;
        const instanceRes = await fetchInstanceGetInstance();

        // if (this.isAndroid()) {
        //     this.resetHtmlFont();
        // }

        if (instanceRes.data && instanceRes.data.status === 0) {
            this.instanceId = Object.keys(instanceRes.data.data)[0];

            this.setState({isLogin: true});
        }
        else if (instanceRes.data && instanceRes.data.status === 401) {
            this.setState({isLogin: false});
        }

        this.getVoucher();
    }

    getVoucher = async () => {
        if (!this.state.isLogin) {
            this.loginUrl();
            return;
        }

        const params = {
            channel: '1'
        };

        if (this.instanceId) {
            params['instance_id'] = this.instanceId;
        }

        const res = await getVoucher(params);

        if (res.status === 0) {
            const serverList = res.data && res.data.service_list || [];
            this.setState({
                serverList,
                voucherList: res.data && res.data.list || [],
                advServer: serverList.find(i => i.version === 'adv'),
                entServer: serverList.find(i => i.version === 'ent')
            });
        }
        else if (res.status === 401) {
            this.loginUrl();
        }
        else if (res.description) {
            this.confirm = confirm({
                title: '',
                content: res.description,
                okText: '关闭',
                isAnimation: false,
                okClick: () => this.confirm && this.confirm()
            });
        }
    }

    getPayUrl(index) {
        const advServer = this.state.advServer || {};
        if (index === 0 || index === 1) {
            return '/console/#/scan/buy?'
                + 'serviceId=' + advServer.service_id
                + '&mealId=' + advServer.meal_id + '&time='
                + (index === 0 ? '2592000' : '31536000');
        }
        // 企业版
        const entServer = this.state.entServer || {};
        if (index === 2) {
            return '/console/#/scan/buy?'
                + 'serviceId=' + entServer.service_id
                + '&mealId=' + entServer.meal_id + '&time=31536000';
        }
    }

    payVoucher = async (item, btnUrl) => {
        const params = {
            'instance_id': this.instanceId,
            'channel': '1',
            'voucher_id': item.voucher_id
        };

        try {
            const localKey = '__abbaidu_20181211_cb';
            const dataStr = localStorage.getItem(localKey);
            const data = JSON.parse(dataStr);
            params.data = data.data;
            params['key_id'] = data.key_id;
            params.sign = data.sign;
        }
        catch (e) {
            params.data = '';
            params['key_id'] = '';
            params.sign = '';
        }

        const res = await payVoucher(params);

        if (res.status === 0) {
            this.confirm = confirm({
                title: '',
                content: '<div class="su-modal-title">已成功领取优惠券</div>'
                    + '进入“ <a class="su-link" target="_blank" href="/console/#/orderView">商务中心</a> ”查看对应优惠券',
                okText: '立即使用',
                isAnimation: false,
                okClick: () => window.location.href = btnUrl
            });
        }
        else if (res.status === 401) {
            window.location.href = this.loginUrl();
        }
        else if (res.description) {
            this.confirm = confirm({
                title: '',
                content: res.description,
                okText: '关闭',
                isAnimation: false,
                okClick: () => this.confirm && this.confirm()
            });
        }
    }

    render() {
        const list = [
            {
                title: '专业版月度套餐',
                url: 'https://anquan.baidu.com/page/5',
                price: 100,
                giftBg: require('../../asset/image/activitySu/ic_wap_1.svg')
            },
            {
                title: '专业版年度套餐',
                url: 'https://anquan.baidu.com/page/5',
                price: 400,
                giftBg: require('../../asset/image/activitySu/ic_wap_2.svg')
            },
            {
                title: '企业版年度套餐',
                url: 'https://anquan.baidu.com/page/5',
                price: 8000,
                giftBg: require('../../asset/image/activitySu/ic_wap_3.svg')
            }
        ];

        const suList = [
            {
                title: '专业版年度套餐',
                url: 'https://su.baidu.com/plan.html',
                price: 200,
                giftBg: require('../../asset/image/activitySu/ic_wap_1.svg'),
                btnUrl: 'https://su.baidu.com/home/buy-plan?plan=pro'
            },
            {
                title: '商业版年度套餐',
                url: 'https://su.baidu.com/plan.html',
                price: 800,
                giftBg: require('../../asset/image/activitySu/ic_wap_2.svg'),
                btnUrl: 'https://su.baidu.com/home/buy-plan?plan=bus'
            },
            {
                title: '企业版年度套餐',
                url: 'https://su.baidu.com/plan.html',
                price: 5000,
                giftBg: require('../../asset/image/activitySu/ic_wap_3.svg'),
                btnUrl: 'https://su.baidu.com/home/buy-plan?plan=ent'
            }
        ];
        return (
            <div className="saas-su-page">
                <div className="saas-su-banner bg"></div>
                <div className="saas-su-banner title1"></div>
                <div className="su-mod-des1">活动期间，领取优惠券即可享受专属优惠，专业版套餐低至199/月，企业版年套餐立减8000元！</div>
                <div className="su-mod-content1">
                    全面资产监控：快速识别资产、大幅提高扫描效率、低成本接入<br />
                    风险资产识别：基于海量漏洞知识库，发现资产风险，保障资产安全<br />
                    漏洞扫描发现：实现对OWASP Top 10漏洞类型、数千高危漏洞POC覆盖达99%以上<br />
                    网页安全检测：快速识别涉黄赌毒、欺诈内容、篡改页面、挂马，规避法律风险
                </div>

                <div className="saas-su-mod1" style={{marginTop: '1rem'}}>
                    {list.map((item, index) => {
                        let btnUrl = this.getPayUrl(index);
                        return (
                            <div key={index} className="child">
                                <div className="child-inner">
                                    <div className="saas-su-card">
                                        <div className="title">
                                            {item.title}
                                        </div>
                                        <a className="link" href={item.url}>
                                            {'产品详情 >'}
                                        </a>
                                        <div className="detail">
                                            <div className="detail-price">{item.price}</div>
                                            <div
                                                className="detail-content">
                                                元专属<br />代金券
                                            </div>
                                            <div
                                                className="detail-btn"
                                                onClick={this.payVoucher.bind(
                                                    this, this.state.voucherList[index] || {}, btnUrl)}>
                                                立即<br />领券
                                            </div>
                                        </div>
                                        <div
                                            className="gift"
                                            style={{backgroundImage: `url(${item.giftBg || ''})`}}></div>
                                        <a
                                            className="btn"
                                            href={btnUrl}>
                                            立即购买
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
                <div className="saas-su-banner title2"></div>
                <div className="saas-su-banner detail1"></div>

                <div className="saas-su-banner title3"></div>

                <div className="saas-su-mod2" style={{marginTop: '1rem'}}>
                    <div className="planlist">
                        <div className="child">
                            <div
                                className="child-inner new-pay">
                                <div className="left">
                                    <div className="title">
                                        <span>新域名享好礼</span>
                                        <span className="title-des">NEW</span>
                                    </div>
                                    <div className="detail">
                                        <span className="detail-price">15天</span>
                                        <span className="detail-conetnt">专业版兑换券</span>
                                    </div>
                                </div>
                                <div className="right">
                                    <a href={'https://m-su.baidu.com/#/activity/5eba43a41768e5f6fa874267?'
                                            + 'hmsr=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F-'
                                            + 'wap&hmpl=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F'
                                            + '-wap&hmcu=&hmkw=&hmci='}
                                    className="right-btn">立 即<br />领 券</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="saas-su-banner title4"></div>
                <div className="saas-su-mod1" style={{marginTop: '1rem', paddingBottom: '1rem'}}>
                    {suList.map((item, index) => {
                        return (
                            <div key={index} className="child">
                                <div className="child-inner">
                                    <div className="saas-su-card">
                                        <div className="title">
                                            {item.title}
                                        </div>
                                        <a className="link" href={item.url}>
                                            {'产品详情 >'}
                                        </a>
                                        <div className="detail">
                                            <div className="detail-price">{item.price}</div>
                                            <div
                                                className="detail-content">
                                                元续费<br />代金券
                                            </div>
                                            <a
                                                href={'https://m-su.baidu.com/#/activity/5eba43a41768e5f6fa874267?'
                                                    + 'hmsr=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F-wap'
                                                    + '&hmpl=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F'
                                                    + '-wap&hmcu=&hmkw=&hmci='}
                                                className="detail-btn">
                                                立即<br />领券
                                            </a>
                                        </div>
                                        <div
                                            className="gift"
                                            style={{backgroundImage: `url(${item.giftBg || ''})`}}></div>
                                        <a
                                            className="btn"
                                            href={'https://m-su.baidu.com/#/activity/5eba43a41768e5f6fa874267?'
                                                + 'hmsr=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F-'
                                                + 'wap&hmpl=%E6%BC%8F%E6%B4%9E%E6%89%AB%E6%8F%8F'
                                                + '-wap&hmcu=&hmkw=&hmci='}>
                                            立即续订
                                        </a>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default connect(
    state => ({
        instanceGetinstance: state.instanceGetinstance
    }),
    dispatch => ({
        fetchInstanceGetInstance: (...args) => fetchInstanceGetInstance(dispatch, ...args)
    })
)(ActivitySu);



// WEBPACK FOOTER //
// ./src/containers/activitySu/index.js